import { createSelector } from 'reselect';
import { RootState } from '../../reducers';

export const getAllEpisodesShowNotes = (state: RootState) => state.episodeShowNotes;

export const getEpisodeShowNotes = createSelector(
    [getAllEpisodesShowNotes, (state: RootState, episodeUuid) => episodeUuid],
    (episodeShowNotes, episodeUuid) => episodeShowNotes[episodeUuid],
);
